const GUEST_SESSION_KEY = 'guestSessionId_client';

export const getGuestSessionId = (): string | null => localStorage.getItem(GUEST_SESSION_KEY);

export const setGuestSessionId = (id: string): void => {
  localStorage.setItem(GUEST_SESSION_KEY, id);
};

export const clearGuestSessionId = (): void => {
  localStorage.removeItem(GUEST_SESSION_KEY);
};
